import { i18n, type MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';

/**
 * "Über diese Daten": one short explanation per master-data class, shown next
 * to the list title, as the catalog tooltip and under the create dialog's title.
 *
 * Interface copy, so it lives here and not in the API: same tone and terms as
 * the rest of the UI, and changing a sentence needs no backend release.
 */
const CLASS_HINTS: Readonly<Record<string, MessageDescriptor>> = {
  ProduktType: msg`Das verkaufte Produkt, z. B. HBE261A. Kunden kaufen Instanzen davon.`,
  ProduktVersion:
    msg`Eine Stückliste des Produkts: entweder ein offizielles Release des Herstellers oder eine Kundenversion – die Konfiguration, die genau eine Produktinstanz tatsächlich fährt. Kundenversionen entstehen beim Upload eines Scans auf die Produktinstanz.`,
  KomponenteVersion:
    msg`Eine Komponente auf einem bestimmten Firmware- oder Software-Stand. Über ihre Kennungen findet Dependency-Track die passenden CVEs.`,
  ProduktVersionKomponente: msg`Welche Komponentenversionen eine Produktversion enthält.`,
  Country:
    msg`Die Länder für die Kundenadresse. „EU-Mitgliedstaat“ bestimmt, ob ein Kunde als EU-Kunde gilt; die CRA-Frühwarnung nennt diese Mitgliedstaaten.`,
  ProduktInstanz:
    msg`Ein ausgeliefertes Gerät bei einem Kunden. Die ausgelieferte Version bleibt fest; die aktuelle Version folgt den Hersteller-Updates oder ist eine eigene Kundenversion, wenn der Kunde selbst Komponenten getauscht hat.`,
  CVE: msg`Manuell erfasste, importierte oder aus KEV-Treffern übernommene CVEs. Alle Scan-Befunde unter „Schwachstellen“.`,
  VulnerabilityEvent:
    msg`Die Bewertung, ob eine CVE auf eine Komponentenversion zutrifft. Der KEV-Scan legt sie an, bewertet wird sie unter „Triage“.`,
  Benachrichtigung:
    msg`Die Mail an einen Kunden zu einer betroffenen Produktversion und CVE. Sie nennt alle betroffenen Anlagen des Kunden und entsteht, wenn die Produktbewertung „Betroffen“ bestätigt wird; die CRA-Meldefristen hängen an der Produktbewertung.`,
  NotificationInstance:
    msg`Welche Anlagen eine Benachrichtigung nennt. Beim Versand wird festgehalten, mit welchem Stand jede Anlage gemeldet wurde.`,
  PsirtTeam:
    msg`Das Product Security Incident Response Team: Meldestelle für Schwachstellen, CVD-Policy und Meldeweg an CSIRT und ENISA (CRA Art. 13 und 14). Gepflegt wird es unter „Verantwortlichkeit“.`,
  ProduktVerantwortung:
    msg`Wer für ein Produkt nach dem CRA einsteht: PSIRT-Team, Product Security Owner, Supportzeitraum und Produktkategorie. Genau eine je Produkt.`,
};

/** The explanation for a class in the active UI language, or null when there is none. */
export function classHint(klass: string | undefined): string | null {
  const hint = klass ? CLASS_HINTS[klass] : undefined;
  return hint ? i18n._(hint) : null;
}
